import http from 'hub-http/clients/apiClient';
const REPORT_REMIX_GENERATION_API = 'report-remix/v1/report-remix';
export const getAIReportRemixes = (report, numberOfRemixes = 3) => {
  return http.post(REPORT_REMIX_GENERATION_API, {
    data: {
      numberOfRemixes,
      report
    }
  });
};